import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { getCurrentUser } from '@/plugins/stitch'
import config from '@/config'

const isProd = process.env.NODE_ENV === 'production'

function init () {
  if (!isProd) { return }

  Sentry.init({
    dsn: config.sentry,
    integrations: [ new Integrations.Vue({ Vue, attachProps: true }) ],
    release: config.version
  })

  const user = getCurrentUser()

  if (user) {
    Sentry.configureScope(scope => {
      scope.setUser({
        id: user.id,
        username: `${user.profile.firstName} ${user.profile.lastName}`,
        email: user.profile.email
      })
    })
  } else {
    Sentry.configureScope(scope => {
      scope.setUser(null)
    })
  }
}

export default init
